import 'css/index.css';
import ReactDom from 'react-dom/client';
import styled from 'styled-components';
import { Box, Hero } from '@ardoq/layout';
import { Link, Paragraph } from '@ardoq/typography';
import { registerImplementation, defaultImplementation } from '@ardoq/logging';
import { CopyrightFooter } from '@ardoq/snowflakes';

const FullScreen = styled.div`
  width: 100%;
  height: 100%;
`;

const ActionLink = styled(Link)`
  display: flex;
  justify-content: center;
`;

registerImplementation(defaultImplementation);

const App = () => {
  return (
    <FullScreen>
      <Hero.Container footer={<CopyrightFooter />}>
        <Hero.Stack>
          <Hero.Header title="Page not found" />
          <Box marginTop="medium">
            <Paragraph variant="text1">
              It looks like this page does not exist or has been moved somewhere
              else
            </Paragraph>
          </Box>
          <Box marginTop="xlarge">
            <ActionLink type="primaryButton" href="/" hideIcon>
              Return to Ardoq
            </ActionLink>
          </Box>
        </Hero.Stack>
      </Hero.Container>
    </FullScreen>
  );
};

const root = ReactDom.createRoot(document.getElementById('root')!);

root.render(<App />);
